import { ResetPasswordFormData } from '../../../entities/@forms/ResetPasswordForm/ResetPasswordForm'
import trans from '../../../helpers/trans'
import {
    FormErrors,
    FormValidation,
    validateForm,
    validatePassword,
    validatePincode,
} from '../../../services/validationService'

export type ResetPasswordFormErrors = FormErrors<ResetPasswordFormData>;

export const validateResetPasswordFormData = (formData: ResetPasswordFormData): FormValidation<ResetPasswordFormErrors> => {
    const {
        password,
        passwordRepeat,
        pincode,
        pincodeRepeat,
    } = formData

    const errors: ResetPasswordFormErrors = {
        password: validatePassword(password),
        pincode: validatePincode(pincode),
    }

    const passwordsAreNotEqual = password && password !== passwordRepeat

    if (passwordsAreNotEqual) {
        errors.passwordRepeat = trans('validation.errors.passwordsAreNotEqual')
    }

    const pincodesAreNotEqual = pincode && pincode !== pincodeRepeat

    if (pincodesAreNotEqual) {
        errors.pincodeRepeat = trans('validation.errors.pincodesAreNotEqual')
    }

    return validateForm<ResetPasswordFormErrors>(errors)
}
